var map = {
	"./email.svg": 3399,
	"./facebook.svg": 6393,
	"./github.svg": 6284,
	"./instagram.svg": 9563,
	"./linkedin.svg": 1959,
	"./pin.svg": 9138,
	"./skype.svg": 1041,
	"./whatsapp.svg": 1899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9067;